const prefix = 'PROVISION2';

export const GET_SERVED_ITEMS_LOADING = `${prefix}_GET_SERVED_ITEMS_LOADING`;
export const GET_SERVED_ITEMS_SUCCESS = `${prefix}_GET_SERVED_ITEMS_SUCCESS`;
export const GET_SERVED_ITEMS_ERROR = `${prefix}_GET_SERVED_ITEMS_ERROR`;

export const GET_CALCULATION_LOADING = `${prefix}_GET_CALCULATION_LOADING`;
export const GET_CALCULATION_SUCCESS = `${prefix}_GET_CALCULATION_SUCCESS`;
export const GET_CALCULATION_ERROR = `${prefix}_GET_CALCULATION_ERROR`;

export const WRITE_PROVISION2_MEALS_LOADING = `${prefix}_WRITE_PROVISION2_MEALS_LOADING`;
export const WRITE_PROVISION2_MEALS_SUCCESS = `${prefix}_WRITE_PROVISION2_MEALS_SUCCESS`;
export const WRITE_PROVISION2_MEALS_ERROR = `${prefix}_WRITE_PROVISION2_MEALS_ERROR`;
export const RESET_WRITE_SUCCESSFUL = `${prefix}_RESET_WRITE_SUCCESSFUL`;

export const RESET_WRITE_ERROR = `${prefix}_RESET_WRITE_ERROR`;
export const RESET_ERROR = `${prefix}_RESET_ERROR`;



// WEBPACK FOOTER //
// ./src/pages/provision2/state/types.js